import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=e3850964&scoped=true&"
import script from "./Inputs.vue?vue&type=script&lang=js&"
export * from "./Inputs.vue?vue&type=script&lang=js&"
import style0 from "./Inputs.vue?vue&type=style&index=0&id=e3850964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3850964",
  null
  
)

export default component.exports